<template>
  <table
    class="min-w-full table-fixed divide-y divide-gray-200 border border-gray-300 rounded-md overflow-hidden text-xs"
  >
    <tbody class="divide-y divide-gray-200">
      <tr
        v-for="(value, key) in itemSummary"
        :key="key"
        class="odd:bg-white even:bg-gray-50"
      >
        <td class="px-4 py-2 font-semibold w-1/3">{{ key }}</td>
        <td class="px-4 py-2 text-gray-700 w-2/3">
          {{ value }}
        </td>
      </tr>
      <tr>
        <td class="px-4 py-2 font-semibold capitalize w-1/3">Attachment</td>
        <td class="px-4 py-2 text-gray-700 w-2/3">
          <div class="grid grid-cols-3 gap-4">
            <div
              v-for="(attachment, index) in formData.AttachmentFiles"
              :key="index"
              class="flex items-center gap-2"
            >
              <CheckSVG v-if="attachment.isdocument" />
              <NoAttachSVG v-else />
              <span>{{ attachment.particular }}</span>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { computed, inject } from "vue";
import CheckSVG from "@/components/svg/CheckSVG.vue";
import NoAttachSVG from "@/components/svg/NoAttachSVG.vue";

export default {
  components: { CheckSVG, NoAttachSVG },
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const moment = inject("$moment");

    const keyMap = {
      approvalno: "Approval Number",
      company: "Company",
      membername: "Member Name",
      availmenttype: "Type of Availment",
      transtype: "Type of Transaction",
      providername: "Provider Name",
      admitdate: "Date of Admission",
      dischargedate: "Date of Discharge",
      symptoms:
        props.formData.availmenttype === "In-Patient"
          ? "Final Diagnosis"
          : props.formData.transtype === "Laboratory"
          ? "Diagnosis"
          : props.formData.transtype === "Consultation"
          ? "Chief Complaint"
          : "Diagnosis",
      contactperson: "Contact Person",
      approvaltype: "Status",
      remarks: "Remarks",
      // Do not map AttachmentFiles here
    };

    const itemSummary = computed(() => {
      const filteredEntries = Object.entries(props.formData).filter(([key]) => {
        const excludedKeys = [
          "AttachmentFiles",
          "renderstartdate",
          "graceperiod",
          "approvaltype",
          "transactionnumber",
          "requestedamount",
          "reimbursableamount",
          "paymentprovider",
          "paymentaccount",
          "paymentstatus",
          "paymentdate",
          "paymentrelease",
          "paymentreference",
          "createdbyid",
          "modifiedbyid",
          "createdAt",
          "updatedAt",
          "admin",
          "reasondothers",
          "declinedreason",
          "declinedremarks",
          "declinedverify",
          "declineddate",
          "paymentpayee",
          "requestdate",
          "declinedreason",
        ];

        if (
          props.formData.availmenttype === "In-Patient" &&
          key === "transtype"
        ) {
          return false;
        }

        if (
          props.formData.availmenttype === "Out-Patient" &&
          key === "dischargedate"
        ) {
          return false;
        }

        return !excludedKeys.includes(key);
      });

      const mappedEntries = filteredEntries.map(([key, value]) => [
        keyMap[key] || key,
        value,
      ]);

      // Handle approvaltype + renderstartdate
      if (props.formData.renderstartdate) {
        let renderStart = props.formData.renderstartdate;
        let renderDays = props.formData.graceperiod;
        let renderEnd = moment(renderStart).add(renderDays, "days");
        mappedEntries.push([
          "Status",
          `${props.formData.approvaltype} Validity: ${moment(
            renderStart
          ).format("LL")} - ${moment(renderEnd).format("LL")}`,
        ]);
      } else if (props.formData.approvaltype) {
        mappedEntries.push(["Status", props.formData.approvaltype]);
      }

      // Add Reason Declined if applicable
      if (
        props.formData.approvaltype &&
        props.formData.approvaltype.toLowerCase().includes("declined")
      ) {
        mappedEntries.push([
          "Reason Declined",
          props.formData.declinedreason || "No reason provided",
        ]);
      }

      return Object.fromEntries(mappedEntries);
    });

    return {
      itemSummary,
    };
  },
};
</script>
